import { State } from 'model/State';
import { selectSwitchedUser } from '../selectors';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { postToHamsClient } from 'util/mac/api/order/post';
import { getFromHamsClient, getFromNonExternalHamsClient } from 'util/mac/api/order/get';
import { downloadStringifiedJSONFromApi } from 'util/mac/downloadJSON';
import { DownloadablePDF, downloadFile } from 'util/mac/downloadFile';

export const searchForContact = (
  state: State,
  maxResultsParam: number,
  offsetParam: number,
  orderNumberMask?: number,
  technicalContactCompanyDomainName?: string,
  integerPartOfTotalAmount?: number,
) => {
  const email = selectSwitchedUser(state);

  return fetchWithParamValidation(
    ({ maxResults, offset }) =>
      postToHamsClient(
        '/searchForContact',
        state,
        {
          maxResults,
          offset,
        },
        {
          email,
          orderNumberMask,
          technicalContactCompanyDomainName,
          integerPartOfTotalAmount,
        },
      ),
    { maxResults: maxResultsParam, offset: offsetParam },
  );
};

export const singleSearchForContact = (orderNumberMask, state: State) => {
  const email = selectSwitchedUser(state);

  return fetchWithParamValidation(
    ({ maxResults, offset }) =>
      postToHamsClient(
        '/searchForContact',
        state,
        {
          maxResults,
          offset,
        },
        {
          email,
          orderNumberMask,
        },
      ),
    { maxResults: 1, offset: 0 },
  );
};

export const invoiceJson = async (orderId: string, state: State, hash?: string) =>
  fetchWithParamValidation(
    async ({ id }) => {
      const url = hash ? `/${id}/summary?hash=${hash}` : `/${id}/summary`;
      const response = await getFromNonExternalHamsClient(url, state);

      downloadStringifiedJSONFromApi(response);
    },
    {
      id: orderId,
    },
  );

export const invoicePdf = async (orderId: string, state: State, hash?: string) =>
  fetchWithParamValidation(
    async ({ id }) => {
      const url = hash ? `/invoice/${id}/pdf?hash=${hash}` : `/invoice/${id}/pdf`;
      const response: DownloadablePDF = await getFromHamsClient(url, state);

      downloadFile(response);
    },
    {
      id: orderId,
    },
  );
